import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale dynamic import chunks after a new deploy.
// When the bundle hash changes, old cached chunks 404; reload once to fetch fresh ones.
const RELOAD_KEY = "__chunk_reload_attempted";
window.addEventListener("error", (event) => {
  const msg = String(event?.message || "");
  if (
    (msg.includes("Failed to fetch dynamically imported module") ||
      msg.includes("Importing a module script failed")) &&
    !sessionStorage.getItem(RELOAD_KEY)
  ) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
});
window.addEventListener("unhandledrejection", (event) => {
  const msg = String(event?.reason?.message || event?.reason || "");
  if (
    (msg.includes("Failed to fetch dynamically imported module") ||
      msg.includes("Importing a module script failed")) &&
    !sessionStorage.getItem(RELOAD_KEY)
  ) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
});
window.addEventListener("load", () => {
  // Clear the guard once a fresh load succeeds.
  setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), 2000);
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
